import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'tran-skip-link',
    templateUrl: './skip-link.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe]
})
export class SkipLinkComponent {
    private readonly document = inject(DOCUMENT);

    public readonly targetId = input.required<string>();
    public readonly labelKey = input('header.skipToContent');
    public readonly placement = input<'top' | 'inline'>('top');
    protected readonly focused = signal(false);

    protected onSkipLinkClick(event: Event, targetId: string): void {
        event.preventDefault();

        const target = this.document.getElementById(targetId);
        if (!target) {
            (event.target as HTMLElement).blur();
            return;
        }

        const firstFocusableElement = target.querySelector<HTMLElement>(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        if (firstFocusableElement) {
            firstFocusableElement.focus();
            return;
        }

        target.setAttribute('tabindex', '-1');
        target.focus();
    }
}
